import React, { useEffect, useState } from 'react'

export const ContextLoading = React.createContext<any>({})


export default function ContextLoadingModels(props: any) {
    const [displayLoading, setDisplayLoading] = useState<boolean>(false)
    const [displayLoadingBlur, setDisplayLoadingBlur] = useState<boolean>(false)
    const [displayLoadingSection, setDisplayLoadingSection] = useState<boolean>(false)
    const [displayLoadingBtn, setDisplayLoadingBtn] = useState<boolean>(false)
    const [displayLoadingSkelton, setDisplayLoadingSkelton] = useState<boolean>(false)
    const [displayNavSkelton, setDisplayNavSkelton] = useState<boolean>(false)


    return (
        <ContextLoading.Provider value={{
            displayLoading,
            setDisplayLoading ,
            displayLoadingBlur,
            setDisplayLoadingBlur,
            displayLoadingSection , 
            setDisplayLoadingSection ,
            displayLoadingBtn,
            setDisplayLoadingBtn,
            displayLoadingSkelton,
            setDisplayLoadingSkelton ,
            displayNavSkelton ,
            setDisplayNavSkelton
        }}>
            {props.children}
        </ContextLoading.Provider>
    )
}